import { Outlet, useNavigate, useLocation, Link } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Logo, StatusBadge } from "@/components/shared";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { LayoutDashboard, Package, ClipboardList, Wallet, BarChart3, CreditCard, Undo2, Building2, LogOut, Menu, X } from "lucide-react";

const NAV = [
  { to: "/manufacturer", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/manufacturer/products", icon: Package, label: "Products" },
  { to: "/manufacturer/orders", icon: ClipboardList, label: "Orders" },
  { to: "/manufacturer/returns", icon: Undo2, label: "Returns" },
  { to: "/manufacturer/settlements", icon: Wallet, label: "Settlements" },
  { to: "/manufacturer/analytics", icon: BarChart3, label: "Analytics" },
  { to: "/manufacturer/subscription", icon: CreditCard, label: "Subscription" },
  { to: "/manufacturer/profile", icon: Building2, label: "Company Profile" },
];

export default function MfgLayout() {
  const nav = useNavigate();
  const loc = useLocation();
  const { logout, profile } = useAuth();
  const [open, setOpen] = useState(false);
  const active = (to, end) => (end ? loc.pathname === to : loc.pathname.startsWith(to));

  return (
    <div className="min-h-screen bg-sgrey lg:flex">
      <aside className={cn("fixed inset-y-0 left-0 z-40 w-64 transform border-r border-border bg-forest transition-transform lg:static lg:translate-x-0",
        open ? "translate-x-0" : "-translate-x-full")}>
        <div className="flex items-center justify-between p-5">
          <Logo dark />
          <button className="text-white lg:hidden" onClick={() => setOpen(false)}><X className="h-5 w-5" /></button>
        </div>
        <div className="px-3 py-2">
          {profile && (
            <div className="mb-3 rounded-lg bg-white/10 p-3">
              <p className="truncate text-sm font-medium text-white">{profile.trade_name}</p>
              <div className="mt-1"><StatusBadge status={profile.verification_status} /></div>
            </div>
          )}
          <nav className="space-y-1">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} data-testid={`mnav-${n.label.toLowerCase().replace(" ", "-")}`} onClick={() => setOpen(false)}
                className={cn("flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors",
                  active(n.to, n.end) ? "bg-white text-forest" : "text-psage hover:bg-white/10")}>
                <n.icon className="h-4 w-4" /> {n.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="absolute bottom-0 w-full p-3">
          <Button data-testid="mfg-logout" variant="ghost" className="w-full justify-start text-psage hover:bg-white/10" onClick={() => { logout(); nav("/"); }}>
            <LogOut className="mr-3 h-4 w-4" /> Log out
          </Button>
        </div>
      </aside>

      {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}

      <div className="flex-1">
        <header className="flex items-center justify-between border-b border-border bg-card px-4 py-3 lg:hidden">
          <button onClick={() => setOpen(true)}><Menu className="h-5 w-5 text-forest" /></button>
          <Logo className="scale-90" />
          <div className="w-5" />
        </header>
        <main className="p-5 lg:p-8"><Outlet /></main>
      </div>
    </div>
  );
}
